<template>
  <div class="page-full-loading">
    <div class="horizontal layout center center-justified fit">
      <Loading />
    </div>
  </div>
</template>

<script>

// components
import { mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Loading from '@/components/Loading'
import cookie from '@/services/cookie'
import util from '@/util'
import PresentationApi from '@/api/presentation'

// services

export default {
  components: {
    Loading,
  },
  computed: {
    ...mapGetters('slideModule', ['defaultSlideConfig']),
  },
  mounted() {
    const isSpinnerWheel = util.getParamValue('spinnerwheel')
    let wheelData = util.getParamValue('wheel-data')
    const isWordCloud = util.getParamValue('wordcloud')
    const wordCloudData = util.getParamValue('wordcloud-data')

    if (isWordCloud) {
      this.handleWordCloud(wordCloudData)
      return
    }

    if (isSpinnerWheel) {
      if (wheelData) {
        try {
          wheelData = JSON.parse(wheelData)
          window.localStorage.setItem('spinnerWheelData', JSON.stringify(wheelData))
        } catch (error) {
          Sentry.captureException(error)
          wheelData = []
        }
      } else {
        wheelData = window.localStorage.getItem('spinnerWheelData')
        try {
          wheelData = JSON.parse(wheelData)
        } catch (error) {
          Sentry.captureException(error)
          wheelData = []
        }
      }
      const token = cookie.getValue('ahaToken')
      if (!token) {
        const query = {
          spinnerwheel: true,
          redirect: '/save-presentation?spinnerwheel=true',
        }
        this.$router.push({ path: '/pages/register', query })
      } else {
        this.createPresentation(wheelData)
      }
    } else {
      this.$router.push({ path: '/apps/presentations' })
    }
  },

  methods: {
    handleWordCloud(wordCloudData) {
      // try get data from url (already signed-in), else, get from localStorage (after register)
      if (wordCloudData) {
        try {
          window.localStorage.setItem('wordCloudData', wordCloudData)
          wordCloudData = JSON.parse(wordCloudData)
        } catch (error) {
          Sentry.captureException(error)
          wordCloudData = []
        }
      } else {
        wordCloudData = window.localStorage.getItem('wordCloudData')
        try {
          wordCloudData = JSON.parse(wordCloudData)
        } catch (error) {
          Sentry.captureException(error)
          wordCloudData = []
        }
      }
      const token = cookie.getValue('ahaToken')
      if (!token) {
        const query = {
          wordcloud: true,
          redirect: '/save-presentation?wordcloud=true',
        }
        this.$router.push({ path: '/pages/register', query })
      } else {
        this.createPresentationWordCloud(wordCloudData)
      }
    },
    async createPresentationWordCloud(wordCloudData) {
      if (!wordCloudData) {
        this.$router.push({ path: '/apps/presentations' })
        return
      }

      const wordCloudEntries = wordCloudData.map((item) => item.title)
      try {
        await PresentationApi.createNewPresentation({
          name: 'Your saved Word Cloud',
          hasDefaultSlide: false,
          wordCloudEntries,
          defaultSlideConfig: this.defaultSlideConfig,
        })
        window.localStorage.removeItem('wordCloudData')
        this.$router.push({ path: '/apps/presentations' })
      } catch (error) {
        Sentry.captureException(error)
        window.localStorage.removeItem('wordCloudData')
        this.$router.push({ path: '/apps/presentations' })
      }
    },
    async createPresentation(wheelData) {
      if (!wheelData) {
        this.$router.push({ path: '/apps/presentations' })
        return
      }

      const spinnerWheelEntries = wheelData.map((item) => item.name)
      try {
        await PresentationApi.createNewPresentation({
          name: 'Your saved Spinner Wheel',
          hasDefaultSlide: false,
          spinnerWheelEntries,
          defaultSlideConfig: this.defaultSlideConfig,
        })
        window.localStorage.removeItem('spinnerWheelData')
        this.$router.push({ path: '/apps/presentations' })
      } catch (error) {
        Sentry.captureException(error)
        window.localStorage.removeItem('spinnerWheelData')
        this.$router.push({ path: '/apps/presentations' })
      }
    },
  },
}
</script>
